var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlaneYellow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 19,
  viewBox: "0 0 22 19",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "d5du8uuzpa",
  x1: "56.552%",
  x2: "50%",
  y1: "79.489%",
  y2: "28.182%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FDDB02"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FBB401"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "oxrgl61n8b",
  x1: "39.627%",
  x2: "9.923%",
  y1: "11.125%",
  y2: "123.758%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFDC02"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FD7000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "74bbmwaq6c",
  x1: "46.347%",
  x2: "35.909%",
  y1: "-4.016%",
  y2: "107.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFDC02"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FD7000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "v4t06qv3hd",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFEF00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFC20B"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  fill: "url(#d5du8uuzpa)",
  transform: "translate(-36 -129) translate(20 110) translate(16 19) translate(0 .08)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.642.034L.417 10.248c-.596.3-.541 1.17.088 1.392l4.873 1.727c.088.03.185.012.256-.048L20.784.246c.114-.1-.007-.28-.142-.212"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#oxrgl61n8b)",
  d: "M6.233 17.455c.072.397.578.526.83.212L20.96.409c.067-.085-.046-.195-.128-.124l-15.2 13.117c-.07.059-.101.15-.085.239l.687 3.814z",
  transform: "translate(-36 -129) translate(20 110) translate(16 19)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "url(#74bbmwaq6c)",
  transform: "translate(-36 -129) translate(20 110) translate(16 19) translate(6.686 1.877)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.098 15.823l1.424-2.992c.323-.68.747-1.308 1.256-1.863L12.755.093c.088-.097.236.03.154.132L.266 15.93c-.074.092-.22 0-.168-.106"
})), /*#__PURE__*/React.createElement("g", {
  fill: "url(#v4t06qv3hd)",
  transform: "translate(-36 -129) translate(20 110) translate(16 19) translate(8.981 .28)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.253 13.635l8.222 3.547c.474.205 1.016-.088 1.105-.597L12.416.373c.051-.295-.314-.475-.516-.254L.111 12.969c-.194.212-.121.552.142.666"
})))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlaneYellow);
export default ForwardRef;